import { useMutation } from "@tanstack/react-query";
import { useAppDispatch } from "store/hooks";
import { addErrorNotification } from "modules/notification/redux/notificationSlice";
import { createCustomerAndSubscriptionByAppsumoApi } from "../../request";

export const useCreateCustomerAndSubscriptionByAppsumo = () => {
  const dispatch = useAppDispatch();

  const {
    mutate: createCustomerAndSubscriptionByAppsumo,
    isPending: isCreateCustomerAndSubscriptionByAppsumoLoading,
  } = useMutation({
    mutationKey: ["createCustomerAndSubscription"],
    mutationFn: createCustomerAndSubscriptionByAppsumoApi,
    onSuccess: () => {
      // reloading to update after subscription is activated
      window.location.href = `${window.location.origin}/my-events`;
    },
    onError: (error: Error) => {
      dispatch(
        addErrorNotification({
          message: error.message,
        }),
      );
    },
  });
  return {
    createCustomerAndSubscriptionByAppsumo,
    isCreateCustomerAndSubscriptionByAppsumoLoading,
  };
};
